module.exports = "/_next/static/images/car-c5f69fe8c81e595c984e0e6c8acfdafe.png";